<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Request access and get your coupons published on offerte.club</h1>
          <h2 class="subtitle">offerte.club collaboration - share your deals with us</h2>
          <b-message type="is-info" has-icon>
            With this form you can request access to offerte.club partnership.
            <br />The partnership is
            <b>free</b> and
            <b>we will review your application.</b>
          </b-message>
          <b-message type="is-danger" has-icon>
            <b>ONLY If your application is approved you will receive an email from us with the login credentials and the instructions.</b>
          </b-message>
        </div>
      </div>
    </section>
    <div class="container" style="margin-top: 30px">
      <b-field label="Email">
        <b-input required v-model="form.email" type="email"></b-input>
      </b-field>

      <b-field label="WeChat">
        <b-input v-model="form.wechat"></b-input>
      </b-field>

      <b-field label="Telegram">
        <b-input v-model="form.telegram"></b-input>
      </b-field>

      <b-field
        label="Store URL (specify Amazon store url or your shop url. If more than one put them separated by comma)"
      >
        <b-input required v-model="form.shop" type="url"></b-input>
      </b-field>

      <div class="buttons is-pulled-right">
        <b-button type="is-primary" :disabled="submitDisabled" @click="submitForm">Request access</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase";

export default {
  name: "RequestAccess",
  data() {
    return {
      form: {
        email: "",
        wechat: "",
        telegram: "",
        shop: ""
      },
      submitDisabled: false
    };
  },
  methods: {
    submitForm() {
      if (!this.form.email || !this.form.shop) {
        this.$buefy.notification.open({
          message: "Fill all the required fields",
          type: "is-warning",
          hasIcon: true
        });
        return;
      }
      this.submitDisabled = true;
      const db = firebase.firestore();

      db.collection("user")
        .where("email", "==", this.form.email)
        .get()
        .then(querySnapshot => {
          const rows = [];
          querySnapshot.forEach(doc => {
            const data = doc.data();
            data.id = doc.id;
            rows.push(data);
          });
          if (rows.length === 0) {
            this.addUser();
          } else {
            this.$buefy.notification.open({
              message: "You already submitted the request",
              type: "is-danger",
              hasIcon: true
            });
          }
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    addUser() {
      const db = firebase.firestore();
      return db
        .collection("user")
        .add({
          email: this.form.email,
          wechat: this.form.wechat,
          telegram: this.form.telegram,
          shop: this.form.shop,
          status: "pending",
          uid: "", // this is the user id from the authorization
          admin: false
        })
        .then(() => {
          console.log(`Request ok`);
          this.$buefy.notification.open({
            message: "Your request has been submitted",
            type: "is-success",
            hasIcon: true
          });
        })
        .catch(function(error) {
          console.error(`Error writing request: ${error}`);
          this.$buefy.notification.open({
            message: "Error sending request",
            type: "is-danger",
            hasIcon: true
          });
          this.submitDisabled = false;
        });
    }
  }
};
</script>
